import axios from 'axios';

/**
 * get list
 */
export const getList = data => axios.$callAPI(() => axios.get('pictures/search', { params: data }));

/**
 * get picInfo
 */
export const getPicInfo = id => axios.$callAPI(() => axios.get('/pictures/' + id));

/**
 * get imageSizeInfo
 */
export const getImageSizeInfo = () => axios.$callAPI(() => axios.get('/pictures/imageSize'));

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('pictures/', data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('pictures/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('pictures/', { data: ids }));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('pictures/' + id, data));
